
export { g as getVisitId } from "./createAnalytics-f979bbf4.js"